import React, { useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";
import { api, errMsg } from "../lib/api";

// Real Stripe Checkout — redirects to Stripe's hosted payment page
const CheckoutModal = () => {
  const { user, authOpen, checkoutPlan, setCheckoutPlan } = useAuth();
  const [busy, setBusy] = useState(false);
  const open = !!checkoutPlan && !!user && !authOpen;

  const pay = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout", { plan_id: checkoutPlan.id, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(errMsg(e, "Could not start checkout."));
      setBusy(false);
    }
  };

  if (!checkoutPlan) return null;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && !busy && setCheckoutPlan(null)}>
      <DialogContent className="gwap-modal" data-testid="checkout-modal">
        <DialogTitle className="modal-title">Checkout</DialogTitle>
        <DialogDescription className="sr-only">Confirm your plan</DialogDescription>
        <div className="co-row"><span>Plan</span><b>{checkoutPlan.name}</b></div>
        <div className="co-row"><span>Access</span><b>{checkoutPlan.id === "monthly" ? "Renews monthly" : `${checkoutPlan.days} days`}</b></div>
        <div className="co-row"><span>Account</span><b>{user?.email}</b></div>
        <div className="co-total"><span>Total{checkoutPlan.id === "monthly" ? " / month" : ""}</span><b>${checkoutPlan.price}.00</b></div>
        <button className="mbtn" onClick={pay} disabled={busy} data-testid="checkout-pay">
          {busy ? <><Loader2 size={14} className="spin" /> Redirecting to Stripe…</> : <><Lock size={13} /> Pay ${checkoutPlan.price} securely →</>}
        </button>
        <div className="co-note">Secure payment by Stripe · Taxes calculated at checkout · All sales final.</div>
      </DialogContent>
    </Dialog>
  );
};

export default CheckoutModal;
